module.exports = __webpack_public_path__ + "img/smartmail-main@3x.538b2c07.png";